
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/soccer/player/[id]",
      function () {
        return require("private-next-pages/soccer/player/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/soccer/player/[id]"])
      });
    }
  